import request from '@/utils/acRequest'

// 历史事件事件类型选项列表
export const getHistoryEventOption = (params) => {
    return request({
        url: '/event/source/option/lists',
        params: params
    })
}
